import Vue from 'vue'
import App from './app'
import store from './store'
import router from './router'

import './plugins/axios'

import 'vuejs-noty/dist/vuejs-noty.css'

import BootstrapVue from 'bootstrap-vue'
import globals from './globals'
import Popper from 'popper.js'
import VueNoty from 'vuejs-noty'
import moment from 'moment'
import VueTheMask from 'vue-the-mask'
import money from 'v-money'
import Vue2Filters from 'vue2-filters'
import BlockUI from 'vue-blockui'
import VueNumberInput from '@chenfengyuan/vue-number-input'
import Vue2TouchEvents from 'vue2-touch-events'
import Hub from './hub'
import Driver from './driver'
import VueCarousel from 'vue-carousel'
import VueObserveVisibility from 'vue-observe-visibility'
import VueScrollTo from 'vue-scrollto'
import UUID from 'vue-uuid'
import { isMfaPreAuthRequest, handleMfaPreAuthUnauthorized } from './utils/mfaPreAuth'
import { rotaParaVoltar } from './utils/returnUrl'

moment.locale('pt-br')

// Required to enable animations on dropdowns/tooltips/popovers
Popper.Defaults.modifiers.computeStyle.gpuAcceleration = false

Vue.config.productionTip = false

function isSsoRedirectDisabled () {
  if (typeof window === 'undefined') return false
  const byEnv = process.env.VUE_APP_DISABLE_SSO_REDIRECT === 'true'
  const byQuery = window.location && /(?:\?|&)e2eDisableSsoRedirect=1(?:&|$)/.test(window.location.search || '')
  const byRuntimeFlag = window.__E2E_DISABLE_SSO_REDIRECT === true
  return byEnv || byQuery || byRuntimeFlag
}

if (isSsoRedirectDisabled() && typeof window !== 'undefined') {
  window.__SSO_REDIRECT_DISABLED = true
  const originalOpen = window.open
  window.open = function (url, target, features) {
    const ssoFront = process.env.VUE_APP_SSO_FRONT || ''
    if (typeof url === 'string' && ssoFront && url.indexOf(ssoFront) === 0) {
      return null
    }
    if (typeof originalOpen === 'function') {
      return originalOpen.call(window, url, target, features)
    }
    return null
  }
}

var Vue2FiltersConfig = {
  capitalize: {
    onlyFirstLetter: false
  },
  currency: {
    symbol: 'R$',
    decimalDigits: 2,
    thousandsSeparator: '.',
    decimalSeparator: ',',
    symbolOnLeft: true,
    spaceBetweenAmountAndSymbol: true
  },
  pluralize: {
    includeNumber: false
  },
  ordinal: {
    includeNumber: false
  }
}

Vue.use(BootstrapVue)
Vue.use(VueNoty)
Vue.use(VueTheMask)
Vue.use(money)
Vue.use(BlockUI)
Vue.use(Vue2Filters, Vue2FiltersConfig)
Vue.use(Vue2TouchEvents)
Vue.use(VueNumberInput)
Vue.use(VueCarousel)
Vue.use(VueObserveVisibility)
Vue.use(VueScrollTo)
Vue.use(UUID)

// Global RTL flag
Vue.mixin({
    data: globals,
    methods: {
      setValue (data, prop, value) {
        Vue.set(data, prop, value)
      },
      deleteValue (data, prop) {
        Vue.delete(data, prop)
      },
      disableAutoComplete () {
        let elements = document.querySelectorAll('[autocomplete="off"]')

        if (!elements) {
          return
        }

        elements.forEach(element => {
          element.setAttribute('readonly', 'readonly')
          element.style.backgroundColor = 'inherit'

          setTimeout(() => {
            element.removeAttribute('readonly')
          }, 500)
        })
      },
      handleResize (e) {
        this.isXS = window.innerWidth < 576
        this.isSM = window.innerWidth >= 576 && window.innerWidth < 768
        this.isMD = window.innerWidth >= 768 && window.innerWidth < 992
        this.isLG = window.innerWidth >= 992 && window.innerWidth < 1200
        this.isXL = window.innerWidth >= 1200 && window.innerWidth < 1600
        this.isXXL = window.innerWidth >= 1600
        if (this.isXS) this.screenSize = 'xs'
        if (this.isSM) this.screenSize = 'sm'
        if (this.isMD) this.screenSize = 'md'
        if (this.isLG) this.screenSize = 'lg'
        if (this.isXL) this.screenSize = 'xl'
        if (this.isXXL) this.screenSize = 'xl'
      },
      setSegfyer (val) {
        this.isSegfyer = val
      }
    },
    created () {
      this.handleResize()
      window.addEventListener('resize', this.handleResize)
    },
    mounted () {
      this.disableAutoComplete()
    },
    beforeDestroy () {
      window.removeEventListener('resize', this.handleResize)
    }
})

// TODO: SignalR
// console.log('Segfy!')
Vue.prototype.moment = moment
Vue.prototype.hub = Hub
Vue.prototype.onboarding = Driver

Vue.filter('toCurrency', function (value) {
  if (typeof value !== 'number') {
      return value
  }
  var formatter = new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL',
      minimumFractionDigits: 2
  })
  return formatter.format(value)
})

Vue.filter('toDate', function (value) {
  if (value === undefined || value === null) {
    return ''
  }
  return moment(value).format('DD/MM/YYYY')
})

Vue.filter('toDateTime', function (value) {
  if (value === undefined || value === null) {
    return ''
  }
  return moment(value).format('DD/MM/YYYY HH:mm')
})

Vue.filter('toTime', function (value) {
  if (value === undefined || value === null) {
    return ''
  }
  return moment(value).format('HH:mm')
})

Vue.filter('companyName', function (value) {
  if (!value) return
  let words = value.split('_')
  let result = ''
  let i = 0
  for (i; i < words.length; i++) {
    result += words[i].charAt(0).toUpperCase() + words[i].slice(1) + ' '
  }
  return result.trim()
})

window.Vue = new Vue({
    router,
    store,
    mixins: [Vue2Filters.mixin],
    render: h => h(App)
})

window.Vue.onboarding.driver.start()

window.Vue.$http.interceptors.request.use(function (config) {
    config.withCredentials = true
    const token = 'Bearer ' + window.Vue.$store.state.auth.token
    config.headers.Authorization = token
    return config
})

window.Vue.$httpNoInterceptor.interceptors.request.use(function (config) {
  config.withCredentials = true
  const token = 'Bearer ' + window.Vue.$store.state.auth.token
  config.headers.Authorization = token
  return config
})

function validateSegfyUpdateFrom503ResponseAndReturnMessage (response) {
  if (!response || !response.data) return null
  const d = response.data
  const text = typeof d === 'string'
    ? d
    : (d && typeof d === 'object' ? [d.message, d.detail, d.error, d.msg].filter(Boolean).join(' ') : '')
  const msg = (text || '').trim()
  if (!msg || !/atualiza/i.test(msg)) return null
  return msg.length <= 200 ? msg : msg.substring(0, 197) + '...'
}

function getServiceHintFromRequest (config) {
  if (!config || !config.url) return ''
  try {
    const url = typeof config.url === 'string' ? config.url : (config.baseURL || '') + (config.url || '')
    const path = url.replace(/^https?:\/\/[^/]+/, '').split('?')[0].trim()
    if (!path || path === '/') return ''
    return '(Serviço: ' + path + ')'
  } catch (_) {
    return ''
  }
}

// Destino pós-SSO de quem perdeu a sessão no meio do uso: só tela que exige login, e com o
// disjuntor contra loop (ver utils/returnUrl).
function opcoesDaVolta () {
  const rota = window.Vue && window.Vue.$router && window.Vue.$router.currentRoute
  return { exigeLogin: !!(rota && rota.matched.some(m => m.meta && m.meta.auth)), storage: window.sessionStorage }
}

function shouldRedirectToSsoOnUnauthorized () {
  return !isSsoRedirectDisabled()
}

const createResponseInterceptor = (httpInstance) => {
  return [
    (response) => {
      switch (response.data.code) {
        case -1:
          return Promise.resolve(response.data)
        case 2:
          window.Vue.$store.state.auth.hash = response.data.data.token
          window.Vue.$router.push({ name: 'auth-expired' })
          break
        case 3:
          window.Vue.$router.push('/login/blocked')
          break
        case 4:
          window.Vue.$router.push('/login/blocked?attempts=1')
          break
        case 5:
          window.Vue.$router.push('/login/blocked')
          break
        default:
          return Promise.resolve(response)
      }
    },
    (error) => {
      // Permite que requests específicos optem por NÃO disparar toasts globais
      // de erro (ex: tela MFA mostra erro inline). Setado no axios config via
      // { skipGlobalErrorNotification: true }.
      const skipGlobalToast = !!(error && error.config && error.config.skipGlobalErrorNotification)

      if (error.response === undefined) {
        if (!skipGlobalToast) {
          window.Vue.$noty.error('Oops... Ocorreu um erro inesperado.<br/>Por favor, tente novamente em alguns minutos ou entre em contato com nossa suporte se o problema persistir.')
        }
      } else if (error.response.status === 401) {
        if (isMfaPreAuthRequest(error.config)) {
          handleMfaPreAuthUnauthorized(window.Vue)
          return Promise.reject(error.response)
        }

        window.Vue.$store._actions['auth/forgetUser'][0]()

        if (!shouldRedirectToSsoOnUnauthorized()) {
          return Promise.reject(error.response)
        }
        
        // Verifica se existe o header X-Redirect-To na resposta 401
        const redirectUrl = error.response.headers['x-redirect-to']
        console.log('redirect to ', redirectUrl)
        
        if (redirectUrl) {
          console.log('redirecting ', redirectUrl)
          // Se o header estiver presente, redireciona para a URL especificada
          window.open(redirectUrl, '_self')
        } else {
          // Preserva return_url no sessionStorage para restaurar após o SSO; sem ele, a tela atual
          // (sessão caiu com o cookie ainda válido — link direto da loja, por exemplo)
          const urlParams = new URLSearchParams(window.location.search)
          const returnUrl = urlParams.get('return_url') || rotaParaVoltar(window.location, opcoesDaVolta())
          if (returnUrl) {
            sessionStorage.setItem('sso_return_url', returnUrl)
          }
          window.open(`${process.env.VUE_APP_SSO_FRONT}/login?callback=${process.env.VUE_APP_SERVER}`, '_self')
        }
      } else if (error.response.status === 503) {
        const msg503 = validateSegfyUpdateFrom503ResponseAndReturnMessage(error.response)
        if (msg503) {
          window.Vue.$noty.error(msg503)
        } else {
          const serviceHint = getServiceHintFromRequest(error.config)
          const userMsg = 'Por favor, aguarde alguns minutos e tente novamente. Se o problema persistir, entre em contato com o suporte.'
          const techDetail = serviceHint ? '<br><br><span style="font-size:0.65em;color:#ccc;">' + serviceHint + '</span>' : ''
          const message = (
            'O serviço solicitado está temporariamente indisponível.' +
            '<br><br><span style="font-size:0.85em;color:#ccc;">' + userMsg + '</span>' +
            techDetail
          )
          window.Vue.$noty.error(message)
        }
      } else {
        if (!skipGlobalToast) {
          window.Vue.$noty.error('A requisição falhou :(')
        }
      }
      return Promise.reject(error.response)
    }
  ]
}

window.Vue.$http.interceptors.response.use(...createResponseInterceptor(window.Vue.$http))

window.Vue.$httpNoInterceptor.interceptors.response.use(
  (response) => {
    return Promise.resolve(response)
  },
  (error) => {
    if (error.response.status === 401) {
      if (isMfaPreAuthRequest(error.config)) {
        handleMfaPreAuthUnauthorized(window.Vue)
        return Promise.reject(error.response)
      }

      window.Vue.$store._actions['auth/forgetUser'][0]()

      if (!shouldRedirectToSsoOnUnauthorized()) {
        return Promise.reject(error.response)
      }
      
      // Verifica se existe o header X-Redirect-To na resposta 401
      const redirectUrl = error.response.headers['x-redirect-to']
      
      if (redirectUrl) {
        // Se o header estiver presente, redireciona para a URL especificada
        window.open(redirectUrl, '_self')
      } else {
        // Mesmo cuidado do interceptor principal: volta para a tela atual depois do SSO
        const returnUrl = new URLSearchParams(window.location.search).get('return_url') || rotaParaVoltar(window.location, opcoesDaVolta())
        if (returnUrl) {
          sessionStorage.setItem('sso_return_url', returnUrl)
        }
        window.open(`${process.env.VUE_APP_SSO_FRONT}/login?callback=${process.env.VUE_APP_SERVER}`, '_self')
      }
    }
    return Promise.reject(error.response)
  }
)

window.Vue.$httpAutomation.interceptors.request.use(function (config) {
  config.withCredentials = false
  return config
})

window.Vue.$httpCookiesOnly.interceptors.request.use(function (config) {
  config.withCredentials = true
  return config
})

window.Vue.$httpCookiesOnly.interceptors.response.use(...createResponseInterceptor(window.Vue.$httpCookiesOnly))

if (store.state.auth.isAuth) {
  window.Vue.hub.connectionFaye.start()

  window.Vue.hub.connectionFaye.sub('logoff', (arg1) => {
    if (arg1 !== null && arg1 !== 'login' + window.Vue.hub.connectionFaye.uid) {
      if (typeof arg1 === 'object') {
          if (arg1.permissao) {
            window.open(`${process.env.VUE_APP_SSO_FRONT}/login?callback=${process.env.VUE_APP_SERVER}`, '_self')
          } else {
              globals().forcelogoff = true
              window.Vue.logoutLegado(globals().forcelogoff)
              window.open(`${process.env.VUE_APP_SSO_FRONT}/login?callback=${process.env.VUE_APP_SERVER}`, '_self')
          }
      } else {
          if (arg1 !== null && arg1 === window.Vue.hub.connectionFaye.uid) {
            window.open(`${process.env.VUE_APP_SSO_FRONT}/login?callback=${process.env.VUE_APP_SERVER}`, '_self')
          } else {
            globals().forcelogoff = true
            window.Vue.logoutLegado(globals().forcelogoff)
            window.open(`${process.env.VUE_APP_SSO_FRONT}/login?callback=${process.env.VUE_APP_SERVER}`, '_self')
          }
      }
      window.Vue.logoutLegado(globals().forcelogoff)
      window.Vue.$store._actions['auth/forgetUser'][0]()
    }
  }, true, false)
}

window.Vue.$mount('#app')
